import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import { computed } from "vue";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsTableRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsTableCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { TicketCheckResultsBoard } from "@/lotteries/model/ticket-check/ticket-check";
import { StringUtils } from "@sazka/utils/string-utils";
import { useWagerBoardStore } from "../../stores/use-wager-board-store";
import { Rychla6BetEvenOdd, Rychla6BetLowHigh, Rychla6BetType } from "@sazka/lotteries/js/models/rychla-6-bet-type";

const EMPTY_CELL_STRING = "–––";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-ticket-check-results-rychla-6-table',
  props: {
    lottery: {},
    results: {}
  },
  setup(__props: any) {

const props = __props;
const boardResult = computed(() => props.results[0]);

const wagerStore = useWagerBoardStore();

const rychla6EvenOddTexts = {
    [Rychla6BetEvenOdd.Even]: "Sudá",
    [Rychla6BetEvenOdd.Equal]: "Stejně",
    [Rychla6BetEvenOdd.Odd]: "Lichá",
};

const rychla6HighLowTexts = {
    [Rychla6BetLowHigh.Low]: "Nízká",
    [Rychla6BetLowHigh.Equal]: "Stejně",
    [Rychla6BetLowHigh.High]: "Vysoká",
};

const getSubGameText = (subGameType: Rychla6BetType, subGameValue: Rychla6BetEvenOdd | Rychla6BetLowHigh) => {
    if (subGameType === Rychla6BetType.EvenOdd) {
        return rychla6EvenOddTexts[subGameValue] || EMPTY_CELL_STRING;
    }

    return rychla6HighLowTexts[subGameValue] || EMPTY_CELL_STRING;
};

const getStake = (boardIndex: number) => {
    const board = wagerStore.boards[boardIndex];

    if (!board.primary?.length) {
        return 0;
    }

    return wagerStore.boards[boardIndex]?.stake;
};

const formatNumberWithCurrency = (amount: number) => {
    if (amount) {
        return StringUtils.formatCurrency(amount);
    }

    return EMPTY_CELL_STRING;
};

const formatMatchingNumbers = (board: TicketCheckResultsBoard) => {
    const formattedPrimary = board.matchingPrimary?.join(", ");

    return formattedPrimary || EMPTY_CELL_STRING;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsTable, {
    "is-scrollable": true,
    "is-responsive": true
  }, {
    default: _withCtx(() => [
      _createVNode(DsTableRow, null, {
        default: _withCtx(() => [
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Uhodnutá čísla")
            ])),
            _: 1,
            __: [0]
          }),
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Vklad")
            ])),
            _: 1,
            __: [1]
          }),
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Sudá / Lichá")
            ])),
            _: 1,
            __: [2]
          }),
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Vklad")
            ])),
            _: 1,
            __: [3]
          }),
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Nízká / Vysoká")
            ])),
            _: 1,
            __: [4]
          }),
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Vklad")
            ])),
            _: 1,
            __: [5]
          }),
          _createVNode(DsTableCell, { type: "th" }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("Výhra")
            ])),
            _: 1,
            __: [6]
          })
        ]),
        _: 1
      }),
      (boardResult.value)
        ? (_openBlock(), _createBlock(DsTableRow, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(DsTableCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(formatMatchingNumbers(boardResult.value)), 1)
                ]),
                _: 1
              }),
              _createVNode(DsTableCell, null, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: formatNumberWithCurrency(getStake(0))
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              }),
              _createVNode(DsTableCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getSubGameText(_unref(Rychla6BetType).EvenOdd, boardResult.value.matchingEvenOdd)), 1)
                ]),
                _: 1
              }),
              _createVNode(DsTableCell, null, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: formatNumberWithCurrency(getStake(1))
                  }, null, 8, _hoisted_2)
                ]),
                _: 1
              }),
              _createVNode(DsTableCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getSubGameText(_unref(Rychla6BetType).LowHigh, boardResult.value.matchingLowHigh)), 1)
                ]),
                _: 1
              }),
              _createVNode(DsTableCell, null, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: formatNumberWithCurrency(getStake(2))
                  }, null, 8, _hoisted_3)
                ]),
                _: 1
              }),
              _createVNode(DsTableCell, null, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: formatNumberWithCurrency(boardResult.value.winAmount)
                  }, null, 8, _hoisted_4)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})